<template>
  <span class="masked-amount">
    <slot v-if="balanceVisible" name="visible"></slot>
    <slot v-else name="hidden">
      <span class="masked-amount-placeholder">{{ placeholder }}</span>
    </slot>
  </span>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'MaskedAmount',
  props: {
    placeholder: {
      type: String,
      default: '******',
    },
  },
  computed: {
    ...mapState('common', ['balanceVisible']),
  },
}
</script>

<style scoped>
.masked-amount {
  display: inline-flex;
  align-items: center;
}

.masked-amount-placeholder {
  letter-spacing: 0.08em;
}
</style>